import {Injectable} from '@angular/core';
import {TradeInstructionsComponent} from '@irb/irb-editors/edit-trading-instructions/trade-instructions/trade-instructions.component';
import {optionOrderTypes, orderTypes} from '../trade-instructions.model';

@Injectable({
    providedIn: 'root',
})
export class TrailingStopOrderTypeFilter {
    trailingStopOrderTypeFilter(parent: TradeInstructionsComponent) {
        /**
         *  @description IREBALUX-1338 Trailing Stop Orders cannot be sent as Not Held orders. If Not Held is specified, Trailing Stop $/% should not be available in the Order Type drop-down field.
         *  @param {boolean} isNotHeld the not held checkbox
         *  @type {object}  orderTypeDD.store The Order Type Dropdown store
         *  @param {object} otDDStore Order type drop down store
         *  @param {boolean} tsAvailable  Trailing Stop $ and Trailing Stop % Order Types are only available on Sell and Sell All orders (not Buys)
         *  @type {object} orderTypeDD Order type drop down dijit.byId("orderType")
         *  @typeDesc orderTypeDDStoreValuesUpdate is fetch query and set display flag in order type store
         */
        const self = parent;
        const item = self.data;
        self.orderTypes = orderTypes; // reset dropdown
        const orderTypeDDValue = self.orderTypeSelected ? self.orderTypeSelected.id : ''; // Get current value of order type
        const isNotHeld = self.notHeld; // Notheld checkbox
        item.showAllTransactionTypeSellAll = item.showAllTransactionTypeSellAll ? item.showAllTransactionTypeSellAll : false;

        //Defect #152845 - IREBALUX-2621 User is able to assign Trailing Stop $ or % order type to buy order when editing multi edit
        let tsAvailable = false;
        if (self.actionType === "MultiEdit" && item.showAllTransactionTypeSellAll && !isNotHeld) {
            tsAvailable = true;
        } else if ((item.transactionType === "SELL" || item.transactionType === "SELL_ALL") && !isNotHeld && self.actionType !== "MultiEdit") {
            tsAvailable = true;
        }

        //If a user selects Not Held on an existing Trailing Stop $/%, then the Order Type should revert to Market. todo: review this comment
        // when !tsAvailable than default to market
        if (!isNotHeld && !tsAvailable && (orderTypeDDValue === "TRAILING_STOP_PRC" || orderTypeDDValue === "TRAILING_STOP_DOLLAR")) {

            self.orderTypeSelected = self.getFilteredValue(self.orderTypes, 'id', 'MARKET');
        }

        self.orderTypes = self.getFilteredArray(orderTypes, 'trailingStopAvailable', (tsAvailable ? 'TRUE' : 'FALSE'));

        //Update dropdown value to display one accepted values
        if (isNotHeld) {
            //IREBALUX-3997 - Defect - Able to Change Order Type from Market to Limit on Existing Not Held Block Desk Order
            const destTypeVal = (self.notHeldDestinationSelected && self.notHeldDestinationSelected.id === "AOM_PRINTER") ? "ORDERTYPEONLY" : "ARRIVAL";

            self.orderTypes = self.getFilteredArray(self.orderTypes, 'destType', destTypeVal);
        } else if (self.actionType !== "MultiEdit") {

            if (self.spreadOptionActionSrv.spreadOptionAction("isSpreadOrder", self)) {

                self.orderTypes = self.getFilteredArray(self.orderTypes, 'destType', "ARRIVAL");
            } else {
                //Defect #153070 - Order Blotter > Edit Trade Instructions for Multiple Securities > Different Symbols > Stop and Stop Limit Displayed in Order Type Drop-down
                self.orderTypes = self.getFilteredArray(self.orderTypes, 'trailingStopAvailable', 'TRUE');
            }

        }
        // if (self.orderTypeSelected) {
        // 	// doing refresh of orderTypeSelected so it would reference current array's element
        // 	self.orderTypeSelected = self.getFilteredValue(self.orderTypes, 'id', self.orderTypeSelected.id);
        // }
        // if (!self.orderTypeSelected) {
        // 	self.orderTypeSelected = self.orderTypes[0];
        // }
        if (self.orderTypeSelected) {
            if (self.orderTypeSelected.id !== orderTypeDDValue) {
                self.orderTypeChanged({value: self.orderTypeSelected});
            }
        }
    }
}
